var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopLeftGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120.5544mm",
    height: "30.344908mm",
    viewBox: "0 0 120.5544 30.344908",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-114.06568,-113.1103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2",
    transform: "matrix(1.6975572,0,0,1.6975572,-212.69053,-156.22253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g9"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fef1d2",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.631067,
      strokeDasharray: "1.8932, 1.8932",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "m 263.50253,158.85376 -70.40412,-0.1947 -0.61228,17.19096 49.32184,0.68467 15.88138,-2.52464 z",
    id: "path4-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fef1d2",
      fillOpacity: 1,
      stroke: "#c78b43",
      strokeWidth: 0.603157,
      strokeDasharray: "1.80947, 1.80947",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "m 261.61911,160.19599 -67.51958,-0.13774 -0.24453,14.34141 45.99817,0.29449 16.34117,-2.22976 z",
    id: "path4-8-6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopLeftGroup);
export default __webpack_public_path__ + "static/media/TopLeftGroup.31ce58f09f182ebe4062e89103231db1.svg";
export { ForwardRef as ReactComponent };